import { z } from 'zod';

import { MatchingRecord } from '@eluve/utils';

export type AppointmentExportTypesEnum =
  | 'HAS_GOLDEN_TRANSCRIPT'
  | 'HAS_GOLDEN_SUMMARY'
  | 'HAS_GOLDEN_FACTS';

export const AppointmentExportTypesLookup = {
  HAS_GOLDEN_TRANSCRIPT: 'HAS_GOLDEN_TRANSCRIPT',
  HAS_GOLDEN_SUMMARY: 'HAS_GOLDEN_SUMMARY',
  HAS_GOLDEN_FACTS: 'HAS_GOLDEN_FACTS',
} as const satisfies MatchingRecord<AppointmentExportTypesEnum>;

export const ExportEnums = {
  AppointmentExportTypes: AppointmentExportTypesLookup,
};

export const appointmentExportTypesSchema = z.nativeEnum(
  AppointmentExportTypesLookup,
);

/**
 * Computed appointment status labels that match the computed field values
 * @see hasura/db_objects/public/function/appointment_status_function.sql
 */
export const ComputedAppointmentStatuses = [
  'AMENDED',
  'AMENDING',
  'SIGNED',
  'SUMMARY_AVAILABLE',
  'ACTIVE',
  'NOT_STARTED',
  'CANCELLED',
  'COMPLETED',
] as const;

/**
 * Possible values for logical appointment status labels
 */
export type ComputedAppointmentStatus =
  (typeof ComputedAppointmentStatuses)[number];
